<template>
  <div>
    <div class="meter-box container lib__no-padding row">
      <div :class="'col-xs-12 col-sm-12 col-md-12 col-lg-12 lib__no-margin lib__no-padding'">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row meter-box top-text-container">

          <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 meter-box title">
            {{ $t('meter.electricityPackage.addConnectionLabel') }}
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 row meter-box price-container">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row lib__no-margin lib__no-padding">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 meter-box price">
                {{ getVATPriceForAdditionnalConnection() }} €
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row meter-box top-text-container">

          <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 meter-box">
            <p class="lib__text-theme lib__text-gray-500 lib__text-weight-500">
              <span>{{ meter.count }} x {{ $tc('meter-box.electricalMeter', getMeterCount()) }},</span>
              <span> {{ $t('meter.type.' + meter.type) }}</span>
            </p>
          </div>
          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 meter-box price-free">
            <p class="no-margin-bottom">{{ $t(getVATLabel()) }}</p>
            <p class="unique-paiement">{{ $t('meter.uniquePaimentLabel') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { vatService } from '@/services/index'
import { ModifiedConnection } from '@/models'

@Component({
  name: 'add-connection-summarized',
  components: {

  }
})
export default class AddConnectionSummarized extends Vue {
  @Prop({ type: Object, required: true }) public meter!: ModifiedConnection
  @Prop({ type: String, required: true }) public applicableVAT!: string

  getVATLabel(): string {
    return vatService.getVatLabel(this.applicableVAT!)
  }

  getVATPriceForAdditionnalConnection(): number {
    return vatService.getVATPriceForAdditionnalConnection(this.meter!, this.applicableVAT!)
  }

  getMeterCount(): number {
    return this.meter.count ? this.meter.count : 0
  }
}
</script>

<style scoped>
.meter-box.container {
  box-sizing: border-box;
  border: 1px solid #c1c7cc;
  border-radius: 4px;
  margin: 20px auto;
}

.unique-paiement {
  margin-top: 5px;
  margin-bottom: 10px;
}

.no-margin-bottom {
  margin-bottom: 0px !important;
}

@media screen and (min-width: 577px) {
  .meter-box.title {
    height: 25px;
    width: 200px;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.top-text-container {
    margin: 10px 0px 0px;
  }

  .meter-box.price {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-free {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-container {
    padding: 0px;
  }

  .meter-box.bottom-text-container {
    margin: 0px 0px 10px;
  }

}

@media screen and (max-width: 576px) {
  .meter-box.title {
    width: 100%;
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }

  .meter-box.top-text-container {
    margin: 20px 0px 0px;
  }

  .meter-box.price {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-free {
    color: #1a262f;
    font-family: 'Open Sans';
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    padding-right: 0px;
  }

  .meter-box.price-container {
    padding: 0px;
  }

  .meter-box.bottom-text-container {
    margin: 10px 0px 0px;
  }

  .meter-box.readonly.description-margin {
    margin-bottom: 20px;
  }
}
</style>